import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getPositionsState = (state: AppState) => state.positions;

export const positionsRequestingSelector = createSelector(getPositionsState, state => state.requesting);
export const positionsSelector = createSelector(getPositionsState, state => state.positions);
